import { apiCall } from "./Interceptor";

const DISCOM_NAME_ALL = "/discom/getAll/public";
const DISCOM_BY_STATE = "/discom/getByState/public";
const GET_ENEGY_CONSUMPTION_CURVE = "/discom/get-heatmap";
const ENERGY_CUNSUMPTION = "/discom/save-heatmap";

const getAllDiscomName = async () => {
 const response = await apiCall.get(DISCOM_NAME_ALL);
 return response;
};

const getDiscomById = async (id) => {
 const response = await apiCall.get(`${DISCOM_BY_STATE}?stateId=${id}`);
 return response;
};
const getEnergyConsumptionCurve = async () => {
 const response = await apiCall.get(GET_ENEGY_CONSUMPTION_CURVE);
 return response;
};
const saveEnergyCunsumtionMonthWise = async (data) =>{
    const response = await apiCall.post(ENERGY_CUNSUMPTION,data);
    return response;
}
export default {
 getAllDiscomName,
 getDiscomById,
 getEnergyConsumptionCurve,
 saveEnergyCunsumtionMonthWise,
};
